import { RuntimeName } from './types';

/**
 * The context errors that can be thrown while working with context manager.
 */

export class StorageDoesNotExists extends Error {
    constructor(runtimeName: RuntimeName) {
        super();
        this.message = `Context manager storage does not exist for ${runtimeName} runtime`;
    }
}

export class ContextDoesNotExist extends Error {
    constructor(contextName: string) {
        super();
        this.message = `Context ${contextName} does not exist, ensure to create it first using "with" method.`;
    }
}

export class ContextAlreadyExists extends Error {
    constructor(contextName: string) {
        super();
        this.message = `Context ${contextName} already exists and cannot re-created over same request`;
    }
}

export class InvalidStorableContext extends Error {
    constructor(contextName: string) {
        super();
        this.message = `Context ${contextName} must be of type object`;
    }
}

export class StorageCreationNotAllowed extends Error {
    constructor(runtimeName: RuntimeName) {
        super();
        this.message = `Creating manager storage using "run" is enabled for "NodeJS" runtime alone, current runtime: ${runtimeName}`;
    }
}

export class ContextCreationNotAllowed extends Error {
    constructor(contextName: string, runtimeName: RuntimeName) {
        super();
        this.message = `Context ${contextName} cannot be created. Creation is enabled for "NodeJS" runtime alone, current runtime: ${runtimeName}`;
    }
}

